/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2InfoFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2InfoFilled({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2InfoFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 13,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2InfoFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 13 12"
 style={{'--as-1-1oHghp': alignSelf,'--mt-2-1oHghp': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1oHghp': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1oHghp': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1oHghp': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1oHghp': opacity,'--w-10-1oHghp': typeof width === 'number' ? `${width}px` : width,'--h-11-1oHghp': typeof height === 'number' ? `${height}px` : height,'--f-12-1oHghp': fill,'--a-7-1oHghp': isAnimated ? animation : "none",'--sd-8-1oHghp': isAnimated ? strokeDashoffset : 0,'--sd-9-1oHghp': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2InfoFilled.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M6.453 12a6 6 0 100-12 6 6 0 000 12zM5.167 8.036a.536.536 0 000 1.071H7.74a.536.536 0 100-1.071h-.75V5.57a.536.536 0 00-.536-.535h-.857a.536.536 0 000 1.071h.321v1.929h-.75zM7.31 3.429a.857.857 0 11-1.714 0 .857.857 0 011.714 0z"
 style={{'--f-12-1oHghp': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}